import { get } from 'lodash';

export const formatAddPayeeDetails = ({ targetPayee, reference }) => ({
	accountNumber: get(targetPayee, 'to_account.account_number'),
	sortCode: get(targetPayee, 'to_account.sort_code'),
	displayName: get(targetPayee, 'display_name', ''),
	reference: reference,
	chapsReference: get(targetPayee, 'reference_high_value'),
	singleUse: false,
	chapsPaymentsEnable: get(targetPayee, 'type', ''),
	payeeAddressLine1: get(targetPayee, 'address.address_line_1', ''),
	payeeAddressLine2: get(targetPayee, 'address.address_line_1', ''),
	payeeCity: get(targetPayee, 'address.city', ''),
	payeePostalCode: get(targetPayee, 'address.postal_code', ''),
	payeeCountry: get(targetPayee, 'address.country', ''),
});
